export const SET_CREATE_JOB_SLIDE = 'SET_CREATE_JOB_SLIDE'
export const SET_ACTIVE_SYSTEM_SETUP_SIDEBAR_ROUTE =
  'SET_ACTIVE_SYSTEM_SETUP_SIDEBAR_ROUTE'
export const SET_CURRENT_SYSTEM_SETUP_DATA = 'SET_CURRENT_SYSTEM_SETUP_DATA'
export const RESET_SYSTEM_SETUP_DATA = 'RESET_SYSTEM_SETUP_DATA'
export const SET_CURRENT_SYSTEM_SETUP_ROWS = 'SET_CURRENT_SYSTEM_SETUP_ROWS'
export const SET_SYSTEM_SETUP_CREATE_EDIT_MODAL =
  'SET_SYSTEM_SETUP_CREATE_EDIT_MODAL'
export const SET_SYSTEM_SETUP_EDITING = 'SET_SYSTEM_SETUP_EDITING'
export const SET_SHOW_ARE_YOU_SURE_MODAL = 'SET_SHOW_ARE_YOU_SURE_MODAL'
export const SET_FORM_SUBMITTED = 'SET_FORM_SUBMITTED'
export const SET_OFFER_LETTER = 'SET_OFFER_LETTER'
export const SET_JOB_SCREENINGS = 'SET_JOB_SCREENINGS'
export const SET_JOB_PROPS = 'SET_JOB_PROPS'
export const SET_SKILLS = 'SET_SKILLS'
export const SET_JOBS = 'SET_JOBS'
export const SET_SHOW_ALERT_MODAL = 'SET_SHOW_ALERT_MODAL'
export const RESET_JOB_PROPS = 'RESET_JOB_PROPS'
export const SET_JOB_DETAIL_ROUTE = 'SET_JOB_DETAIL_ROUTE'
export const SET_JOB_APPLICATIONS = 'SET_JOB_APPLICATIONS'
export const SET_APPLICATION_DETAIL_ROUTE = 'SET_APPLICATION_DETAIL_ROUTE'
export const SET_JOB_APPLICATION = 'SET_JOB_APPLICATION'
export const SET_ARCHIVED_JOBS = 'SET_ARCHIVED_JOBS'
export const SET_ONBOARDINGG_JOBS = 'SET_ONBOARDINGG_JOBS'
export const SET_INTERVIEWS = 'SET_INTERVIEWS'
export const SET_APPLICATION_NOTES = 'SET_APPLICATION_NOTES'
export const SET_APPLICATION_TODO = 'SET_APPLICATION_TODO'
export const SET_ALL_APPLICATIONS = 'SET_ALL_APPLICATIONS'
export const SET_FILTER_START_DATE = 'SET_FILTER_START_DATE'
export const SET_FILTER_END_DATE = 'SET_FILTER_END_DATE'
export const SET_FILTER_JOB_STAGE = 'SET_FILTER_JOB_STAGE'
export const SET_FILTER_JOB = 'SET_FILTER_JOB'
export const RESET_APPLICATION_FILTERS = 'RESET_APPLICATION_FILTERS'
export const SET_CAREER_JOBS = 'SET_CAREER_JOBS'
export const SET_JOB_TRACKING_ID = 'SET_JOB_TRACKING_ID'
export const SET_TRACKING_RESULT = 'SET_TRACKING_RESULT'
export const SET_OFFER_LETTER_DATA = 'SET_OFFER_LETTER_DATA'
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'
export const SET_CREATING_APPLICATION = 'SET_CREATING_APPLICATION'
export const SET_REVIEWING_APPLICATIONS = 'SET_REVIEWING_APPLICATIONS'
export const SET_AI_INTERVIEW_INTRODUCTION = 'SET_AI_INTERVIEW_INTRODUCTION'
export const SET_AI_INTERVIEW_CONCLUSION = 'SET_AI_INTERVIEW_CONCLUSION'
export const SET_AI_INTERVIEW_QUESTIONS = 'SET_AI_INTERVIEW_QUESTIONS'
export const SET_STOP_INTERVIEW_ON_TAB_CHANGE =
  'SET_STOP_INTERVIEW_ON_TAB_CHANGE'
export const RESET_AI_INTERVIEW_SETUP = 'RESET_AI_INTERVIEW_SETUP'
export const SET_AI_INTERVIEW_RANKINGS = 'SET_AI_INTERVIEW_RANKINGS'
export const SET_APPEALS = 'SET_APPEALS'
